/**
 * Wishlist toggle — Swym Wishlist Plus SDK.
 * Buttons: .js-wishlist-btn (PDP ATC pill + product cards)
 *
 * Clicks bind immediately via delegation (do not wait for SwymCallbacks).
 * Product lookup uses getProductDetails('/products/handle') so locale prefixes
 * like /en/ do not send a du Swym does not recognise.
 */
(function () {
  'use strict';

  var headerReady = false;
  var observerReady = false;
  var pendingBtn = null;

  function absUrl(url) {
    if (!url) return '';
    if (url.indexOf('//') === 0) return 'https:' + url;
    return url;
  }

  function buildProductFromPageData(pageData) {
    return {
      epi: pageData.epi,
      empi: pageData.empi,
      du: pageData.du,
      dt: pageData.dt,
      iu: absUrl(pageData.iu),
      pr: pageData.pr
    };
  }

  function buildProductFromButton(btn) {
    var productId = Number(btn.getAttribute('data-product-id'));
    var variantId = Number(btn.getAttribute('data-variant-id'));
    var price = parseFloat(btn.getAttribute('data-product-price'));
    var handle = btn.getAttribute('data-product-handle') || '';

    return {
      epi: variantId,
      empi: productId,
      du: btn.getAttribute('data-product-url') || (handle ? window.location.origin + '/products/' + handle : window.location.href),
      dt: btn.getAttribute('data-product-title') || '',
      iu: absUrl(btn.getAttribute('data-product-image') || ''),
      pr: isNaN(price) ? undefined : price
    };
  }

  function resolveProduct(btn) {
    var pageData = window.SwymPageData;
    var productId = Number(btn.getAttribute('data-product-id'));
    var isPdpBtn = btn.id === 'pdp-wishlist-btn';

    if (isPdpBtn && pageData && pageData.et === 1 && Number(pageData.empi) === productId) {
      return buildProductFromPageData(pageData);
    }

    return buildProductFromButton(btn);
  }

  function applyVariant(product, variantId) {
    if (!variantId) return;
    var info = window.SwymProductVariants && window.SwymProductVariants[variantId];
    if (info) {
      product.epi = info.epi;
      if (info.pr != null) product.pr = info.pr;
      if (info.iu) product.iu = absUrl(info.iu);
      if (info.du) product.du = info.du;
    } else {
      product.epi = variantId;
    }
  }

  function updateButtonState(btn, isWishlisted) {
    if (!btn) return;
    var addLabel = btn.getAttribute('data-add-label') || 'Add to wishlist';
    var removeLabel = btn.getAttribute('data-remove-label') || 'Remove from wishlist';
    btn.classList.toggle('swym-added', isWishlisted);
    btn.setAttribute('aria-pressed', isWishlisted ? 'true' : 'false');
    btn.setAttribute('aria-label', isWishlisted ? removeLabel : addLabel);
  }

  function withSwymProduct(swat, btn, callback) {
    var fallback = resolveProduct(btn);
    var handle = btn.getAttribute('data-product-handle') || '';

    if (typeof swat.getProductDetails !== 'function' || !handle) {
      callback(fallback);
      return;
    }

    swat.getProductDetails({ du: '/products/' + handle }, function (json) {
      if (!json) {
        callback(fallback);
        return;
      }

      var variant = json.variants && json.variants[0];
      callback({
        empi: json.empi || json.id || fallback.empi,
        epi: json.epi || (variant && variant.id) || fallback.epi,
        du: json.du || fallback.du,
        dt: json.dt || json.title || fallback.dt,
        iu: absUrl(json.iu || fallback.iu),
        pr: json.pr != null ? json.pr : fallback.pr
      });
    }, function () {
      callback(fallback);
    });
  }

  function idsMatch(item, product) {
    return Number(item.empi) === Number(product.empi) && Number(item.epi) === Number(product.epi);
  }

  function syncButtonState(swat, btn, wishlisted) {
    var product = resolveProduct(btn);
    var list = Array.isArray(wishlisted) ? wishlisted : [];
    updateButtonState(btn, list.some(function (item) {
      return idsMatch(item, product);
    }));
  }

  function syncAllStates(swat) {
    swat.fetch(function (wishlisted) {
      document.querySelectorAll('.js-wishlist-btn').forEach(function (btn) {
        syncButtonState(swat, btn, wishlisted);
      });
    });
  }

  function normalizeCount(products) {
    if (Array.isArray(products)) return products.length;
    if (products && Array.isArray(products.items)) return products.items.length;
    return 0;
  }

  function currentHeaderCount() {
    var sr = document.querySelector('.js-wishlist-count .sr-only');
    return parseInt(sr && sr.textContent, 10) || 0;
  }

  function updateHeaderCount(count) {
    document.querySelectorAll('.js-wishlist-count').forEach(function (el) {
      el.hidden = count === 0;
      var sr = el.querySelector('.sr-only');
      if (sr) sr.textContent = String(count);
    });
  }

  function refreshHeaderCount(swat) {
    swat.fetch(function (products) {
      updateHeaderCount(normalizeCount(products));
    });
  }

  function scheduleHeaderRefresh(swat) {
    refreshHeaderCount(swat);
    setTimeout(function () {
      refreshHeaderCount(swat);
    }, 400);
  }

  function toggleWishlist(swat, btn) {
    if (btn.disabled) return;
    btn.disabled = true;

    var done = function () {
      btn.disabled = false;
    };

    withSwymProduct(swat, btn, function (product) {
      if (btn.id === 'pdp-wishlist-btn') {
        var form = btn.closest('form');
        var variantInput = form
          ? form.querySelector('[name="id"]')
          : document.querySelector('product-form [name="id"], form[action*="/cart/add"] [name="id"]');
        if (variantInput && variantInput.value) {
          applyVariant(product, Number(variantInput.value));
        }
      }

      var onError = function () {
        done();
      };

      if (btn.classList.contains('swym-added')) {
        swat.removeFromWishList(product, function () {
          updateButtonState(btn, false);
          updateHeaderCount(Math.max(0, currentHeaderCount() - 1));
          scheduleHeaderRefresh(swat);
          done();
        }, onError);
      } else {
        swat.addToWishList(product, function () {
          updateButtonState(btn, true);
          updateHeaderCount(Math.max(1, currentHeaderCount() + 1));
          scheduleHeaderRefresh(swat);
          done();
        }, onError);
      }
    });
  }

  function requestConsent() {
    var Consentmo = window.Consentmo;
    if (!Consentmo || typeof Consentmo.openDialog !== 'function') return;

    try {
      Consentmo.openDialog('banner');
    } catch (e1) {
      try {
        Consentmo.openDialog('preferences');
      } catch (e2) {}
    }
  }

  function flushPending(swat) {
    if (!pendingBtn || !document.contains(pendingBtn)) {
      pendingBtn = null;
      return;
    }
    var btn = pendingBtn;
    pendingBtn = null;
    toggleWishlist(swat, btn);
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.js-wishlist-btn');
    if (!btn) return;
    event.preventDefault();
    if (window._swat) {
      toggleWishlist(window._swat, btn);
      return;
    }
    pendingBtn = btn;
    requestConsent();
  }, true);

  function initHeaderCount(swat) {
    if (headerReady) return;
    headerReady = true;
    refreshHeaderCount(swat);

    if (!swat.evtLayer) return;

    var onChange = function () {
      scheduleHeaderRefresh(swat);
      syncAllStates(swat);
    };

    swat.evtLayer.addEventListener('sw:addedtowishlist', onChange);
    swat.evtLayer.addEventListener('sw:removedfromwishlist', onChange);
    swat.evtLayer.addEventListener('sw:addedtocart', onChange);
  }

  function start(swat) {
    if (!swat) return;

    syncAllStates(swat);
    initHeaderCount(swat);
    flushPending(swat);

    if (observerReady || typeof MutationObserver === 'undefined') return;
    observerReady = true;

    var timer;
    var observer = new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        syncAllStates(swat);
      }, 200);
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  function waitForSwat() {
    if (window._swat) {
      start(window._swat);
      return;
    }

    var poll = null;

    function beginPoll() {
      if (poll || window._swat) {
        if (window._swat) start(window._swat);
        return;
      }
      var tries = 0;
      poll = setInterval(function () {
        if (window._swat) {
          clearInterval(poll);
          poll = null;
          start(window._swat);
        } else if (++tries >= 100) {
          clearInterval(poll);
          poll = null;
        }
      }, 100);
    }

    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(start);
    beginPoll();

    document.addEventListener('consentmoSignal', beginPoll);
    document.addEventListener('visitorConsentCollected', beginPoll);

    if (window.Consentmo && window.Consentmo.events && window.Consentmo.events.ConsentUpdate) {
      document.addEventListener(window.Consentmo.events.ConsentUpdate, beginPoll);
    } else {
      document.addEventListener('consentmoSignal_onLoad', function () {
        if (window.Consentmo && window.Consentmo.events && window.Consentmo.events.ConsentUpdate) {
          document.addEventListener(window.Consentmo.events.ConsentUpdate, beginPoll);
        }
      });
    }
  }

  waitForSwat();
})();
